import type { RouteParamsGeneric } from 'vue-router'
import type { IPageDataInfo, TSeoLocalData } from './interfaces'
import type { TPageKey, TPagePath } from '@/pages-hooks/route-paths'
import { pathToPageKey } from '@/pages-hooks/route-paths'
import { getLcidFromRouteParams } from '../route-params'

// import the SEO locales from static files
import enUS from './locales-seo/en.json'
// import itIT from './locales-seo/it.json'
// import esES from './locales-seo/es.json'

export const seoDataMap: Record<string, TSeoLocalData> = {
  en: <any>enUS,
  'en-us': <any>enUS,
  // it: <any>itIT,
  // es: <any>esES,
}

const _getPageData = (lcid: string, pageKey: TPageKey): IPageDataInfo => {
  //lcid = lcid || _getCurrentLocale()
  if (!seoDataMap[lcid]) {
    console.warn(`localization: _getPageData: missing entry in SEO locale data for locale "${lcid}"`)
    return {
      lcid,
      title: pageKey,
      description: pageKey,
    }
  }
  if (!seoDataMap[lcid] || !seoDataMap[lcid][pageKey]) {
    console.warn(
      `localization: _getPageData: missing entry in SEO locale data ("${lcid}") for page "${pageKey}"`,
    )
    return {
      lcid,
      title: pageKey,
      description: pageKey,
    }
  }
  return seoDataMap[lcid][pageKey]
}

// returns the localized page seo information
export const getPageDataByRoute = (path: string, params: RouteParamsGeneric): IPageDataInfo => {
  const lcid = getLcidFromRouteParams(params)
  const typedPath: TPagePath = path.replace(`/${lcid}`, '/').replace('//', '/') as any
  let pageKey = pathToPageKey[typedPath]
  if (typeof pageKey === 'undefined') {
    console.warn(
      `getPageDataByRoute: could not find pageKey for typedPath "${typedPath}" (${path})`,
      lcid,
      pageKey,
    )
    pageKey = 'home'
  } else {
    // console.log('getPageDataByRoute', path, lcid, pageKey)
  }
  return _getPageData(lcid, pageKey)
}
